import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IFiltros } from '../interface-regional-parametro';
import { ServiceAppService } from '../../../../security/service-app.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-regional-parametro-filtro',
  templateUrl: './regional-parametro-filtro.component.html',
  styleUrls: ['./regional-parametro-filtro.component.scss']
})
export class RegionalParametroFiltroComponent implements OnInit {
  @Input() filtros: IFiltros;
  @Input() exibeFiltros: boolean = true;
  @Output() fecharModalFiltros: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() aplicarFiltros: EventEmitter<IFiltros> = new EventEmitter<IFiltros>();

  ngOnInit() {
  }

 
  hideDialog() {
    this.exibeFiltros = false;
    this.fecharModalFiltros.emit(this.exibeFiltros);
  }

  enviarFiltros() {
    this.aplicarFiltros.emit(this.filtros);
    this.exibeFiltros = false;
  }

  limpafiltros() {
    this.filtros = {
      paginaAtual: null, quantidadeRegistrosPorPagina: null, descricaoRegiao: '', nomeContato: '',
     }
    this.aplicarFiltros.emit(this.filtros);
    this.exibeFiltros = false;
  }
}
